import { list } from './_duck'

export const LIST_GET_REQUEST: string = list.defineType('LIST_GET_REQUEST')
export const LIST_GET_SUCCESS: string = list.defineType('LIST_GET_SUCCESS')
export const LIST_GET_FAILURE: string = list.defineType('LIST_GET_FAILURE')
